/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconSocialStarEmpty = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M2.096 6.774l3.363 2.473a.5.5 0 0 1 .179.556l-1.282 3.976 3.349-2.437a.501.501 0 0 1 .588-.001l3.35 2.426-1.281-3.96a.498.498 0 0 1 .179-.557l3.364-2.476H9.753a.5.5 0 0 1-.475-.346L8 2.495 6.722 6.428a.5.5 0 0 1-.476.346h-4.15zm1.313 8.812a.5.5 0 0 1-.476-.653l1.643-5.095L.275 6.675a.5.5 0 0 1 .297-.902h5.311L7.524.722c.134-.412.818-.412.951 0l1.642 5.051h5.311a.499.499 0 0 1 .296.902l-4.3 3.166 1.642 5.074a.501.501 0 0 1-.769.56L8 12.363 3.703 15.49a.497.497 0 0 1-.294.096z"
    />
  </svg>
);

IconSocialStarEmpty.displayName = 'IconSocialStarEmpty';

IconSocialStarEmpty.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconSocialStarEmpty);
IconSocialStarEmpty.displayName = 'IconSocialStarEmpty';
